const StripTags = (string: any) => {
  if (!string || !string?.replaceAll) return;
  let replaced = '';
  replaced = string.replaceAll(/<[^>]*>/g, '');
  return replaced;
};

export { StripTags };
